import { PageShell } from '../components/PageShell';

export function Clientes() {
  return (
    <PageShell
      titulo={<h1 className="text-xl font-semibold text-gray-800 dark:text-gray-100">👥 Clientes</h1>}
      className="flex flex-col h-screen overflow-hidden bg-transparent"
      semMain
    >
      <div className="flex-1 w-full relative">
        <iframe
          src="/gestaoclientes/index.html"
          className="w-full h-full border-none bg-transparent"
          allowTransparency={true}
          title="Gestão de Clientes"
        />
      </div>
    </PageShell>
  );
}
